import SingleTicketActions from './SingleTicketActions';

export default SingleTicketActions;
